module.exports = __webpack_public_path__ + "static/notice-actions-dont-bb1f3f5574ad897bebce3f9a25420b43.png";